<template>
  <AggregateSalesDashboard
    title="臨時作業 売上情報"
    eyebrow="Temporary Work Sales"
    description="臨時作業の受注金額（税抜）を請求年月基準で集計します。臨時作業一覧と同じ計上基準で、カテゴリ比較と月別推移を確認できます。"
    period-basis-label="請求年月"
    :tabs="tabs"
    :theme="theme"
  />
</template>

<script>
import AggregateSalesDashboard from '@/components/aggregate/AggregateSalesDashboard.vue';
import {
  getAggregateTemporaryWorkSalesByBuilding,
  getAggregateTemporaryWorkSalesByBusinessClassification,
  getAggregateTemporaryWorkSalesByCustomer,
  getAggregateTemporaryWorkSalesByInCharge,
  getAggregateTemporaryWorkSalesByMonth,
  getAggregateTemporaryWorkSalesByVendor,
} from '@/api/axios';
import { createAggregateTabs } from '@/utils/aggregateDashboard';

const tabs = createAggregateTabs({
  buildingFetcher: getAggregateTemporaryWorkSalesByBuilding,
  customerFetcher: getAggregateTemporaryWorkSalesByCustomer,
  vendorFetcher: getAggregateTemporaryWorkSalesByVendor,
  businessFetcher: getAggregateTemporaryWorkSalesByBusinessClassification,
  inChargeFetcher: getAggregateTemporaryWorkSalesByInCharge,
  monthFetcher: getAggregateTemporaryWorkSalesByMonth,
});

const theme = {
  accent: '#1f8c63',
  accentSoft: '#dcf7ed',
  accentStrong: '#166247',
  accentRgb: '31, 140, 99',
  surfaceAlt: '#f3fcf7',
  border: '#d3eadf',
  textMuted: '#5f756e',
};

export default {
  name: 'TemporaryWorkSalesByData',
  components: {
    AggregateSalesDashboard,
  },
  setup() {
    return {
      tabs,
      theme,
    };
  },
};
</script>
